import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'Nombre de tarjeta'},
    {title: 'Cuenta de mayor'},
    {title: 'ID sociedad'},
    {title: 'Teléfono'}
    ];

class CardsListModal extends Component {
    componentDidMount() {
        this.closeAction();
    }

    closeAccount = async () => {
        $('#cardsListModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#cardsListModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };


    render() {
        const {data, selectAccount} = this.props;

        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="cardsListModal"></div>;
        }
        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll"  role="dialog"  id="cardsListModal"  aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Lista de Cuentas</h4>
                                <button type="button" className="close" onClick={this.closeAccount} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div  className="w-100 table-scroll tab-pane fade show active "  aria-labelledby="nav-home-tab-Contenido" >
                                                <table className="table response" style={{marginBottom: 0}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"cardsListModal"} action={selectAccount}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeAccount}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CardsListModal;